<template>
  <div class="loans-footer">
    <div
      style="float: left; padding-left: 10px; height: 50px; line-height: 50px"
    >
      {{ $t("loans.Amount") }} :
      <span class="data-down" style="font-size: 18px">{{
        parseFloat(safeMoney).toFixed(2)
      }}</span>
    </div>
    <van-button
      @click="toPageSubmit"
      class="web-btn-fail"
      style="float: right; margin: 2px 10px; min-width: 120px"
      ><van-loading v-if="posting" /><span v-else>{{ safeBtnName }}</span></van-button
    >
  </div>
</template>

<script>
export default {
  name: "LoanFoot",
  props: ["money", "btnName","posting"],
  computed: {
    safeMoney() {
      return this.money || 0;
    },
    safeBtnName() {
      return this.btnName || "";
    },
    safePosting(){
      return this.posting || false
    }
  },
  watch: {
    money() {},
    btnName() {},
    posting(){}
  },
  methods: {
    toPageSubmit() {
      this.$emit("page-submit");
    },
  },
};
</script>

<style>
</style>
